import tippy, {followCursor} from 'tippy.js';
window.tippy = tippy;
window.followCursor = followCursor;

import ClipboardJS from 'clipboard';
window.ClipboardJS = ClipboardJS;
